import { action } from "typesafe-actions";
import ActionTypes from "../constants";

export const liveChatLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_live_chat_icon",
    customAttributes: {
      isViewEvent: true,
      ...customAttributes
    }
  });

export const chatIconClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_live_chat_icon",
    customAttributes: {
      ...customAttributes
    }
  });

export const viewPageOopsPage = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_oops_page",
    customAttributes: {
      ...customAttributes
    }
  });

export const tpToCompModalLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tp_to_comp_nudge_modal_loaded",
    customAttributes: {
      ...customAttributes
    }
  });

export const compToZdModalLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "comp_to_zd_nudge_modal_loaded",
    customAttributes: {
      ...customAttributes
    }
  });

export const abFeatureNameAndVal = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "ab_feature_flag",
    customAttributes: {
      ...customAttributes
    }
  });

export const viewPagePlanScreenMountedWithoutPlans = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_plan_screen_mounted_without_plans",
    customAttributes: {
      ...customAttributes
    }
  });

export const amazonIllogicalRedirectCTAClick = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "Clicked_Renew_Now_On_Amazon",
    customAttributes: {
      ...customAttributes
    }
  });

export const viewPageAmazonBadRoi = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_amazon_bad_roi",
    customAttributes: {
      ...customAttributes
    }
  });

export const premiumApiFailed = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "api_failed_error",
    customAttributes: {
      ...customAttributes
    }
  });

export const PlansApiTriggered = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "plans_api_triggered",
    customAttributes: {
      ...customAttributes
    }
  });

export const PlansApiSuccess = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "plans_api_success",
    customAttributes: {
      ...customAttributes
    }
  });

export const updateProposalApiTriggered = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "update_proposal_api_triggered",
    customAttributes: {
      ...customAttributes
    }
  });

export const updateProposalApiSuccess = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "update_proposal_api_success",
    customAttributes: {
      ...customAttributes
    }
  });

export const updateProposalApiFailed = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "update_proposal_api_failed",
    customAttributes: {
      ...customAttributes
    }
  });
